/**
 * Exposes the host Jotai store and atoms on window so MFEs can share state
 * without a direct dependency coupling.
 * MFEs must be on a jotai version ≤ host's version, same major, ideally same minor.
 * @example
 * // In an MFE:
 * import { useAtom } from 'jotai'
 * const { store, selectedAccountAtom } = window.SHARED_ATOMS
 * const [selectedAccount, setSelectedAccount] = useAtom(selectedAccountAtom, { store })
 */
import { jotaiStore } from 'store'
import {
  givenNameAtom,
  modalStatusAtom,
  selectedAccountAtom,
  statementsFlowRefAtom
} from './atoms'

const sharedAtoms = {
  store: jotaiStore,
  givenNameAtom,
  modalStatusAtom,
  selectedAccountAtom,
  statementsFlowRefAtom
} as const

declare global {
  interface Window {
    SHARED_ATOMS: typeof sharedAtoms
  }
}

if (!window.SHARED_ATOMS) {
  window.SHARED_ATOMS = Object.freeze(sharedAtoms)
}
